import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["button", "content"];

  connect() {
    this.closeAll();
  }

  toggle(event) {
    const button = event.currentTarget;
    const index = this.buttonTargets.indexOf(button);
    const content = this.contentTargets[index];

    if (content.classList.contains("hidden")) {
      this.closeAll();
      content.classList.remove("hidden");
      button.classList.add("active");
    } else {
      content.classList.add("hidden");
      button.classList.remove("active");
    }
  }

  closeAll() {
    this.contentTargets.forEach((content) => content.classList.add("hidden"));
    this.buttonTargets.forEach((button) => button.classList.remove("active"));
  }
}
